@if (href()) {
  <a
    [finLink]="href()"
    [external]="externalLink()"
    [openInNewTab]="openInNewTab()"
    class="block relative no-underline"
    [class]="computedTheme()"
    [class.button-medium]="size() === ButtonSize.MEDIUM"
    [class.button-large]="size() === ButtonSize.LARGE"
    [class.ps-small-x]="size() === ButtonSize.MEDIUM"
    [class.ps-medium-x]="size() === ButtonSize.LARGE"
    [class.btn-fill]="fillMode()"
    [class.btn-fill-mobile]="fillModeMobile()"
    [attr.tabindex]="removeFromNavigation() ? '-1' : undefined"
    [attr.title]="title()"
    [attr.role]="ariaRole()"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-describedby]="aria()?.describedby"
    [attr.aria-controls]="aria()?.controls"
    [attr.aria-selected]="aria()?.selected"
    [attr.aria-hidden]="aria()?.hidden"
    [attr.aria-expanded]="aria()?.expanded"
    [attr.aria-posinset]="aria()?.posinset"
    [attr.aria-setsize]="aria()?.setsize"
    [attr.id]="id()"
    [rel]="rel()"
    (click)="onClick($event)"
    (blur)="blurBtn.emit()"
  >
    <ng-container
      *ngTemplateOutlet="
        textTemplate;
        context: {
          icon: icon,
          loading: loading,
          size: size,
          text: text,
        }
      "
    />
  </a>
} @else {
  <button
    (click)="onClick($event)"
    [type]="type()"
    [class]="computedTheme()"
    class="block relative"
    [class.button-medium]="size() === ButtonSize.MEDIUM"
    [class.button-large]="size() === ButtonSize.LARGE"
    [class.ps-small-x]="size() === ButtonSize.MEDIUM"
    [class.ps-medium-x]="size() === ButtonSize.LARGE"
    [class.btn-fill]="fillMode()"
    [class.btn-fill-mobile]="fillModeMobile()"
    [disabled]="disabled() || loading()"
    [attr.tabindex]="removeFromNavigation() ? '-1' : undefined"
    [attr.title]="title()"
    [attr.role]="ariaRole()"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-describedby]="aria()?.describedby"
    [attr.aria-controls]="aria()?.controls"
    [attr.aria-disabled]="aria()?.disabled"
    [attr.aria-selected]="aria()?.selected"
    [attr.aria-hidden]="aria()?.hidden"
    [attr.aria-expanded]="aria()?.expanded"
    [attr.aria-posinset]="aria()?.posinset"
    [attr.aria-setsize]="aria()?.setsize"
    [attr.id]="id()"
    (blur)="blurBtn.emit()"
    #buttonElement
  >
    <ng-container
      *ngTemplateOutlet="
        textTemplate;
        context: {
          icon: icon,
          loading: loading,
          size: size,
          text: text,
        }
      "
    />
  </button>
}

<ng-template #textTemplate let-loading="loading" let-size="size" let-text="text">
  <span class="flex">
    @if (icon() && icon().position === IconPosition.LEFT) {
      <ng-container *ngTemplateOutlet="iconTemplate; context: { icon, loading, size }" />
    }
    @if (text() !== '' || loading()) {
      <span
        class="force-width text flex font-body-1 bold-type font-body-medium-bold"
        [class.ps-xxsmall-r]="icon() && IconPosition.RIGHT"
        [class.ps-xxsmall-l]="icon() && IconPosition.LEFT"
      >
        @if (text() !== '') {
          <span
            class="break-word nowrap truncate overflow-hidden"
            [class.hide-element]="loading()"
            [attr.aria-hidden]="loading()"
            >{{ text() }}</span
          >
        }
        @if (loading()) {
          <fcom-loader class="absolute center-icon" [loaderType]="LoaderTheme.BUTTON" />
        }
      </span>
    }
    @if (icon() && icon().position === IconPosition.RIGHT) {
      <ng-container *ngTemplateOutlet="iconTemplate; context: { icon, loading, size }" />
    }
  </span>
</ng-template>

<ng-template #iconTemplate let-icon="icon" let-loading="loading" let-size="size">
  <fcom-icon
    class="flex--nogrow flex--self-center"
    role="presentation"
    [category]="icon().category"
    [name]="icon().name"
    [ngClass]="{
      'icon-medium': size() === ButtonSize.MEDIUM || size() === ButtonSize.LARGE,
      'hide-element': loading(),
    }"
  />
</ng-template>
